const awsconfig = {
  Auth: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_OBY1PC7Ka',
    userPoolWebClientId: '1fjtl9g9j4qmv8dtd9o5eea932',
  },
};

export default awsconfig;